// extracted by mini-css-extract-plugin
export default {"documentProof":"documentProof_documentProof__LbT8Q"};